import script from "./RepaymentPeriods.vue?vue&type=script&setup=true&lang=js"
export * from "./RepaymentPeriods.vue?vue&type=script&setup=true&lang=js"

import "./RepaymentPeriods.vue?vue&type=style&index=0&id=cccb328a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cccb328a"]])

export default __exports__